import { render, staticRenderFns } from "./schooleLinkage.vue?vue&type=template&id=276daa13&scoped=true&"
import script from "./schooleLinkage.vue?vue&type=script&lang=js&"
export * from "./schooleLinkage.vue?vue&type=script&lang=js&"
import style0 from "./schooleLinkage.vue?vue&type=style&index=0&id=276daa13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276daa13",
  null
  
)

export default component.exports